export default "__VITE_ASSET__CU$$BuHK__"